import styled from 'styled-components';

export const Form = styled.form`
  margin: 0;
  padding: 0;
`;

export const LineSpacer = styled.div`
  width: 100%;
  height: 2px;
  background-color: #eae7e7;
  margin: 30px 0;
`;

export const DuoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr fit-content(100%);
  row-gap: 16px;
  column-gap: 16px;
  align-items: stretch;
  grid-auto-columns: 1fr;
  grid-column: span 2;

  @media only screen and (max-width: 500px) {
    grid-template-columns: 1fr;
    grid-column: unset;
  }
`;
